var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "toolbar"
  }, [_c('div', {
    staticClass: "bd"
  }, [_c('giftwall', {
    ref: "giftwall",
    attrs: {
      "authentication": _vm.authentication,
      "giftList": _vm.giftList,
      "giftTabs": _vm.giftTabs,
      "isOpenGiftWall": _vm.isOpenGiftWall
    },
    on: {
      "sendgift": _vm.sendGiftHandler,
      "opengiftwall": _vm.openGiftWallHandler
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ft"
  }, [_c('authorization', {
    ref: "authorization",
    attrs: {
      "authentication": _vm.authentication
    },
    on: {
      "recharge": _vm.rechargeHandler,
      "authenticate": _vm.authenticateHandler
    }
  })], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };